









import { Vue, Component } from 'vue-property-decorator';

@Component
export default class BaseLoading extends Vue {}
